import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { ItemGroupingsComponent } from '@emm/management/components/item-groupings/item-groupings.component';

@Injectable({
    providedIn: 'root'
})
export class ConfirmItemGroupingsDeactivateGuard  {

    canDeactivate(
        component: ItemGroupingsComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return component
            .checkIfItemHasChanges(component.prevItem)
            .pipe(take(1));
    }

}
